import { Box, Typography, Grid, Button } from "@mui/material";
import { GREEN_LOGO, WHITE, GREEN_MAIN } from "../../theme/colors";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { Trans } from "react-i18next";
import settings from "../../utilities/settings";
import { checkUserEnabled } from "../../helpers/authorizedUser";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useUserContext } from "../../hooks/auth/UserProvider";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export const MarketInfo = () => {
    const {t} = useTranslationContext();
    const {user, auth, checkIsAuth} = useUserContext();
    const navigate = useNavigate();
    const [isEnabled, setIsEnabled] = useState(false);
    const {isForbidden} = useUserContext();

    useEffect(() => {
        if(isForbidden){
            navigate('/');
        }
    }, [isForbidden]);

    useEffect(() => {
        if (auth.isLoading) return;
    
        // Se l'utente non è autenticato → fai partire il login con redirect alla pagina corrente
        if (!auth.isAuthenticated) {
            auth.signinRedirect({ state: window.location.pathname });
            return;
        }
    
        // Se autenticato ma user non è abilitato → torna alla home
        if (auth.user && user && !checkUserEnabled(user)) {
            navigate('/');
            return;
        }
    
        // Se tutto ok → abilita la vista
        setIsEnabled(true);
    
        // Esegui comunque il controllo auth
        checkIsAuth().finally();
    
    }, [auth.isLoading, auth.isAuthenticated, auth.user, user, navigate]);
    
    return(
        !isForbidden ? <Box sx={{
            width:'100%', 
            display:'flex', 
            flexDirection:'column',
            color: GREEN_MAIN,
            fontFamily:'poppins'
          }}>
            <Grid container justifyContent='center' paddingBottom={5}>
                <Grid item xs={12} sm={9} md={6}>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            mb: 0,
                            mt: 0,
                            fontWeight: "bold",
                        }}
                    >
                        {t("Il Mercato online")}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container justifyContent='center' paddingBottom={5}>
                <Grid item xs={12} sm={9} md={6}>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '1em',
                            mb: 2,
                            textAlign:"justify",
                            display: "flex",
                            flexWrap: "nowrap"
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Trans i18nKey='market-info-description' components={{
                                1: <a href="https://www.assobay.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}/>,
                            }} />
                        </Box>
                    </Typography>

                    <Box sx={{ my: 2, ml: 1 }}>
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '1em',
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                                textAlign: "justify",
                                flexWrap: "nowrap"
                            }}
                        >
                            <Box component="span" sx={{ mr: 1, color: "darkgreen", flexShrink: 0 }}>
                                ▸
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Trans i18nKey='market-info-marketplace' components={{
                                    1: <strong />
                                }} />
                            </Box>
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '1em',
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                                textAlign: "justify",
                                flexWrap: "nowrap"
                            }}
                        >
                            <Box component="span" sx={{ mr: 1, color: "darkgreen", flexShrink: 0 }}>
                                ▸
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Trans i18nKey='market-info-announcements' components={{
                                    1: <strong />
                                }} />
                            </Box>
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '1em',
                                display: "flex",
                                alignItems: "center",
                                mb: 2,
                                textAlign: "justify",
                                flexWrap: "nowrap"
                            }}
                        >
                            <Box component="span" sx={{ mr: 1, color: "darkgreen", flexShrink: 0 }}>
                                ▸
                            </Box>
                            <Box sx={{ flex: 1 }}>
                                <Trans i18nKey='market-info-gas' components={{
                                    1: <strong />
                                }} />
                            </Box>
                        </Typography>
                    </Box>

                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '1em',
                            mb: 2,
                            textAlign:"justify",
                            display: "flex",
                            flexWrap: "nowrap"
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Trans i18nKey='market-info-description-2' components={{
                                1: <strong />,
                            }} />
                        </Box>
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '1em',
                            mb: 2,
                            textAlign:"justify",
                            display: "flex",
                            flexWrap: "nowrap"
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Trans i18nKey='market-info-description-3' components={{
                                1: <strong />,
                                2: <br/>,
                                3: <a href="https://www.assobay.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} />
                            }} />
                        </Box>
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '1em',
                            mb: 2,
                            textAlign:"justify",
                            display: "flex",
                            flexWrap: "nowrap"
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Trans i18nKey='market-info-description-end' components={{
                                1: <strong />,
                                2: <a href="https://www.assobay.com" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}} />
                            }} />
                        </Box>
                    </Typography>


                </Grid>
            </Grid>

            <Grid container justifyContent='center' paddingBottom={3}>
                <Grid item xs={12} sm={9} md={6}
                    //onClick={() => window.open(settings.MarketPlace.Url, '_blank')}
                    onClick={() => {}}
                    sx={{
                        cursor: 'pointer', // fa comparire la manina al passaggio
                        '&:hover': {
                            opacity: 0.8,     // opzionale: effetto visivo al passaggio
                        },
                    }}
                >
                    <img src={`/${settings.MarketPlace.Logo}`} style={{
                        maxWidth:'250px'
                    }}/>
                </Grid>
            </Grid>

            <Grid container justifyContent='center' paddingBottom={3}>
                <Grid item xs={12} sm={9} md={6}>
                    <Grid container justifyContent='center' spacing={2} fontSize="0.8em">
                        <Grid item xs={12} sm='auto'>
                            <Button variant="contained" 
                                //onClick={() => window.open(settings.MarketPlace.Url, '_blank')}
                                onClick={() => {}}
                                sx={{
                                    color:WHITE, 
                                    border:'0',
                                    backgroundColor: GREEN_LOGO,
                                    '&:hover':{
                                        backgroundColor:'darkgreen'
                                    },
                                    textTransform: 'none'
                            }}>
                                {t("Compra online")}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm='auto'>
                            <Button variant="contained" 
                                onClick={() => window.open(settings.PortaleAnnunci.Url, '_blank')}
                                sx={{
                                    color:WHITE, 
                                    border:'0',
                                    backgroundColor: GREEN_LOGO,
                                    '&:hover':{
                                        backgroundColor:'darkgreen'
                                    },
                                    textTransform: 'none'
                            }}>
                                {t("Pubblica un annuncio")}
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm='auto'>
                            <Button variant="contained" 
                                onClick={() => window.open(settings.PortaleGAS.Url, '_blank')}
                                sx={{
                                    color:WHITE, 
                                    border:'0',
                                    backgroundColor: GREEN_LOGO,
                                    '&:hover':{
                                        backgroundColor:'darkgreen'
                                    },
                                    textTransform: 'none'
                            }}>
                                {t("Organizza un Gruppo d'acquisto")}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box> : <></>
    )
}